module.exports = __webpack_public_path__ + "d33a4ce549b7ba7d29e7cd35e95a19fd.png";